import styled from 'styled-components';

import { Icon, IconName } from 'components/Icon';
import { Color } from 'theme';

const paddingSize = '12px';

const Container = styled.div<{ $paddingLeft: boolean; $paddingRight: boolean }>`
  line-height: 0;

  ${({ $paddingLeft }) => ($paddingLeft ? `padding-left: ${paddingSize};` : '')}
  ${({ $paddingRight }) =>
    $paddingRight ? `padding-right: ${paddingSize};` : ''}
`;

type Props = {
  iconColor?: Color;
  iconName: IconName;
  noPaddingLeft?: boolean;
  noPaddingRight?: boolean;
  size?: number;
};

export function InputIcon({
  iconColor = 'lightContentGrey',
  iconName,
  noPaddingLeft,
  noPaddingRight,
  size = 18,
}: Props) {
  return (
    <Container $paddingLeft={!noPaddingLeft} $paddingRight={!noPaddingRight}>
      <Icon
        initialColorName={iconColor}
        name={iconName}
        size={size}
        keepColorOnLoad
      />
    </Container>
  );
}
